module.exports = __webpack_public_path__ + "static/img/contact.50f19e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/other/contact.png
// module id = 1598
// module chunks = 0